/**
 * User-facing messages shown when a sign-in method has been disabled
 * account-wide by the tenant admin (Settings → Company → Login methods).
 *
 * The sign-in endpoints don't reject a disabled method, so the login screen is
 * responsible for blocking it and surfacing these. Wording mirrors the backend
 * `LoginMethodDisabled` examples in swagger/auth.json.
 */

export const SSO_LOGIN_DISABLED_MESSAGE =
  'Single sign-on (SSO) has been disabled by your account administrator. Please sign in with your email and authenticator code.'

export const MFA_LOGIN_DISABLED_MESSAGE =
  'Email + authenticator sign-in has been disabled by your account administrator. Please sign in with SSO.'
